import { authedApiFetch } from '../../utils/Api';
import { redirect } from 'react-router';

// Loader that reads pagination/sort params from the URL and passes them to the backend
export const clientLoader = async ({ params, request }) => {
	try {
		// Access control check in the loader, which runs before navigation completes.
		const user = JSON.parse(sessionStorage.getItem('user'));

		if (
			user?.role !== 'altvia_admin' &&
			user?.role !== 'altvia_power_user' &&
			user?.role !== 'tenant_admin'
		) {
			throw redirect(`/tenants/${params.tenantId}/marketplace`);
		}

		// Get pagination, sorting, and filter parameters from the URL
		const url = new URL(request.url);
		const page = url.searchParams.get('page') || 0;
		const per = url.searchParams.get('per') || 10;
		const sort_column = url.searchParams.get('sort_column') || 'created_at';
		const sort_order = url.searchParams.get('sort_order') || 'desc';
		const provider = url.searchParams.get('provider') || '';
		const status = url.searchParams.get('status') || '';
		const user_search = url.searchParams.get('user_search') || '';
		const user_id = url.searchParams.get('user_id') || '';

		// Build query string with all parameters
		const queryParams = new URLSearchParams({
			page,
			per,
			sort_column,
			sort_order,
			...(provider && { provider }),
			...(status && { status }),
			...(user_search && { user_search }),
			...(user_id && { user_id }),
		});

		// Fetch jobs and users in parallel
		const [tenant_jobs, email_sync_users] = await Promise.all([
			authedApiFetch({
				endpoint: `/tenants/${params.tenantId}/email_jobs?${queryParams}`,
				method: 'GET',
			}),
			authedApiFetch({
				endpoint: `/tenants/${params.tenantId}/users/email_sync_users`,
				method: 'GET',
			}),
		]);

		//returns the same format as the AscentEmail.jsx component's clientLoader, which is used by the useEmailJobsPoller hook
		return { jobs: tenant_jobs, users: email_sync_users };
	} catch (error) {
		console.error(`Error loading email jobs.`, error);
		throw error;
	}
};
